var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eden-confirm-dialog',{attrs:{"title":'Delete Menu Type',"button-type":'danger',"button-text":'Yes, Delete',"cancel-text":'No, Cancel',"button-status":_vm.deleting,"show":_vm.setShow},on:{"update:show":function($event){_vm.setShow=$event},"confirm":_vm.deleteMenuType}},[_c('p',[_vm._v("Are you sure you want to delete this menu type?")])])
}
var staticRenderFns = []

export { render, staticRenderFns }